import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import Header from '../components/Header.js';
import './doctorProfile.css';

export default function DoctorProfile() {
    const { doctorId } = useParams();
    
    const [doctor, setDoctor] = useState(null);

    useEffect(() => {
        fetch(`https://oculus-api.onrender.com/api/doctors/${doctorId}`)
            .then(res => res.json())
            .then(data => {
                setDoctor(data);
            })
            .catch(err => console.error("Error fetching doctor:", err));
    }, [doctorId]);

    if (!doctor) {
        return <div className="loading-message">Loading doctor details...</div>;
    }

    return (
        <div className="doctor-profile-page">
            <Header/>
            
            <div className='profile-header-card'>
                <div className='profile-header-content'>
                    
                    <div className='profile-image-container'>
                        <img 
                            src={doctor.image} 
                            alt={doctor.name}
                            className='profile-photo'
                        />
                    </div>
                    
                    <div className='profile-info-text'>
                        <h1 className='doctor-name'>{doctor.name}</h1>
                        <h3 className='doctor-specialization'>{doctor.specialization}</h3>
                        {/* <button className="book-btn-header">Book Appointment</button> */}
                    </div>

                </div>
            </div>

            <div className='profile-details-container'>
                
                <section className='detail-section'>
                    <h2 className='section-title'>Overview</h2>
                    <p className='doctor-bio'>{doctor.bio}</p>
                </section>

                <div className='credentials-grid'>
                    <section className='detail-section'>
                        <h3 className='subsection-title'>Education</h3>
                        <ul className='credential-list'>
                            {doctor.education.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </section>

                    <section className='detail-section'>
                        <h3 className='subsection-title'>Experience</h3>
                        <ul className='credential-list'>
                            {doctor.experience && doctor.experience.map((item, index) =>(
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </section>
                </div>

            </div>
        </div>
    );
}